import apiServiceCall from "../services/ApiServiceCall";

const token = process.env.REACT_APP_TOKEN as string;

export const registerSponsoredService = (request: registerRequest) => {
  return apiServiceCall()
    .post("/pending/create-with-sponsor-solo", request, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: registerServiceResponse) => data);
};

export const registerLimitService = () => {
  return apiServiceCall()
    .get("/pending/formAvailable")
    .then(({ data }: IRegisterLimitServiceResponse) => data);
};

export const validateSponsorCodeSoloService = (request: { code: string }) => {
  return apiServiceCall()
    .post("/patrocinador/validate-code-solo", request, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: validateSponsorCodeServiceResponse) => data);
};

export interface IRegisterLimitServiceResponse {
  data: {
    available: boolean;
  };
}

export interface registerRequest {
  sponsored_players: boolean;
  sponsor: string;
  name: string;
  proam:number;
  lastname: string;
  email: string;
  phone_number: string;
  mobile_number: string;
  company: string;
  document_type: number;
  document_number: string;
  sex: number;
  tshirt_size: number;
  ghin: number;
  handicap: number;
  diestro: number;
  glove_size: number;
  include_guest: boolean;
  guest_name: string;
  guest_lastname: string;
  guest_email: string;
  guest_document_type: string;
  guest_document: string;
}

interface registerServiceResponse {
  data: {
    ok: boolean;
    msg: string;
    error: string;
  };
}

interface validateSponsorCodeServiceResponse {
  data: {
    ok: boolean;
    proam_courtesy: boolean;
    proam: boolean;
    sponsor: {
      has_players: number;
      id: number;
      id_categoria: number;
      nombre: string;
      prioridad: number;
      url_imagen: string;
      website: string;
    };
  };
}
